<div class="card sidenav no-padding padding-bottom">
	<!-- <div class="logo margin-bottom-large padding-left padding-right">
		<img src="assets/img/logo.jpg" />
	</div> -->

	@for(group of sidenavGroups; track group; let first = $first){
	<ng-container>
		<div class="menu">
			@for(item of group.groupItems; track item){
			<div
				class="item flex padding-small center"
				[ngClass]="{ selected: group.groupUrlPart === currentGroupUrlPart && item.itemUrlPart === currentItemUrlPart }"
				(click)="onClickItem(group, item)"
				*btHasRole="item.requiredRoles"
				>
				<!-- <div class="icon flex-0 margin-right-small"><i [class]="'fa-solid ' + item.iconName"></i></div> -->
				@if(item.isCustom){
					<mat-icon [svgIcon]="item.iconName"></mat-icon>
				}@else{
					<mat-icon [fontIcon]="item.iconName"></mat-icon>
				}
				<div class="label flex-1" [title]="item.itemName">{{ item.itemName }}</div>
			</div>
			}
		</div>
	</ng-container>
	}

	<!--
	<div [routerLink]="'/user/homepage'">homepage</div>
	<div [routerLink]="'/user/login'">login</div>
	<div [routerLink]="'/user/signup'">signup</div>
	<div [routerLink]="'/user/existing-account'">existing-account</div>
	<div [routerLink]="'/user/forgot-password'">forgot-password</div>
	<div [routerLink]="'/user/inactive-account'">inactive-account</div>
	<div [routerLink]="'/user/password-reset'">password-reset</div> -->
</div>
